import { BackendBaseModel, coerceNullToUndefined } from '@/utils';
import { z } from 'zod';

import { WorkflowModel, WorkflowStageFormStageFieldSchema } from './workflow';

const WorkflowTemplateDataModel = z.object({
  title: WorkflowModel.shape.title.nullish().transform(coerceNullToUndefined),
  tagIds: z.string().uuid().array().nullish().transform(coerceNullToUndefined),
  content: WorkflowModel.shape.content
    .nullish()
    .transform(coerceNullToUndefined),
  workflowType: WorkflowModel.shape.workflowType
    .nullish()
    .transform(coerceNullToUndefined),
  stages: WorkflowStageFormStageFieldSchema.extend({
    stageType: WorkflowStageFormStageFieldSchema.shape.stageType
      .nullish()
      .transform(coerceNullToUndefined),
  })
    .array()
    .nullish()
    .transform(coerceNullToUndefined),
});

export const WorkflowTemplateModel = BackendBaseModel.extend({
  name: z.string().min(1),
  data: WorkflowTemplateDataModel.nullable(),
});

export const WorkflowTemplatesModel = WorkflowTemplateModel.array();

export const WorkflowTemplateFormSchema = WorkflowTemplateDataModel.extend({
  name: WorkflowTemplateModel.shape.name,
});

export const UpdateWorkflowTemplateParamsSchema =
  WorkflowTemplateFormSchema.extend({
    id: z.string().uuid(),
  });
